import React, { useState, useEffect } from 'react'
import { BiChevronUp } from 'react-icons/bi'

const MoveUp = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    return (
        <>
            {isVisible && (
                <div className='move-up' onClick={scrollToTop}>
                    <BiChevronUp size={20} />
                </div>
            )}
        </>
    )
}

export default MoveUp